import React from "react";
import Navbar from "../../components/base/landing/navbar";
import FooterLanding from "../../components/base/landing/footer";
import EsoBachiller from "../../components/base/landing/eso_bachiller";
import WhatsApp from "../../components/base/whatsapp";
import BlogButton from "../../components/base/blog";


const EsoBachillerPage = () => {
    return (
      <>
        <Navbar />
        <EsoBachiller/>
        <FooterLanding/>
        <BlogButton/>
        <WhatsApp/>
      </>
    );
  };
  
  export default EsoBachillerPage;